import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "@core-services/state.service";
import { CashPlusSubscriptionsApi } from "@modules/cashplus/entities/cashplus.model";

export interface CashPlusSubscriptionsState extends CashPlusSubscriptionsApi {
	error: boolean;
}

const initialState: CashPlusSubscriptionsState | null = null;

@Injectable({
	providedIn: "root"
})
export class CashplusSubscriptionsStateService extends StateService<CashPlusSubscriptionsState> {
	public constructor() {
		super(initialState);
	}

	public getState$(): Observable<CashPlusSubscriptionsState> {
		return this.select((state) => state);
	}

	public updateState(model: CashPlusSubscriptionsState): void {
		this.setState(model);
	}

	public isSubscriptionsLoaded(): boolean {
		return this.isStateLoaded();
	}

	public hasError(): boolean {
		return this.state?.error;
	}

	public updateSubscription(optIn: boolean): void {
		this.setState({
			subscribed: optIn
		});
	}
}
